import React from 'react';
import styles from './NavItem.module.scss';

type Props = {
  icon: string;
  label: string;
  active: boolean;
  children?: React.ReactNode;
}

const NavItem: React.FC<Props> = ({
  icon,
  label,
  active,
  children,
}) => (
  <div className={`${styles.item} ${active ? styles.active : ''}`}>
    <i className={`iconfont ${icon} ${styles.itemIcon}`} />
    <span className={styles.itemLabel}>{label}</span>
    {children}
  </div>
);

export default NavItem;
